import React from 'react';

const Discover = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="26"
      viewBox="0 0 42 26"
      fill="none"
      {...props}
    >
      <rect width="42" height="26" rx="3" fill="#FFFFFF" stroke="#E5E5E5" />
      <ellipse cx="21" cy="13" rx="8" ry="6" fill="#F47216" />
      <path
        d="M4 10H6C7.5 10 8.5 11 8.5 12.5C8.5 14 7.5 15 6 15H4V10ZM5.5 13.5H6C6.5 13.5 7 13.2 7 12.5C7 11.8 6.5 11.5 6 11.5H5.5V13.5Z"
        fill="#231F20"
      />
      <path d="M9 10H10.5V15H9V10Z" fill="#231F20" />
      <path
        d="M11 14L12 13.5C12.2 14 12.5 14.2 13 14.2C13.4 14.2 13.7 14 13.7 13.7C13.7 13.4 13.4 13.2 12.8 13C12 12.7 11.5 12.3 11.5 11.5C11.5 10.7 12.2 10 13.2 10C14 10 14.5 10.3 14.8 10.8L13.8 11.3C13.6 11 13.4 10.8 13.1 10.8C12.8 10.8 12.6 11 12.6 11.3C12.6 11.5 12.8 11.7 13.3 11.9C14.2 12.2 14.8 12.6 14.8 13.5C14.8 14.4 14 15 13 15C12.2 15 11.4 14.6 11 14Z"
        fill="#231F20"
      />
      <path
        d="M31 14L32 13.5C32.2 14 32.5 14.2 33 14.2C33.4 14.2 33.7 14 33.7 13.7C33.7 13.4 33.4 13.2 32.8 13C32 12.7 31.5 12.3 31.5 11.5C31.5 10.7 32.2 10 33.2 10C34 10 34.5 10.3 34.8 10.8L33.8 11.3C33.6 11 33.4 10.8 33.1 10.8C32.8 10.8 32.6 11 32.6 11.3C32.6 11.5 32.8 11.7 33.3 11.9C34.2 12.2 34.8 12.6 34.8 13.5C34.8 14.4 34 15 33 15C32.2 15 31.4 14.6 31 14Z"
        fill="#231F20"
      />
      <path
        d="M35.5 10H39V11.2H37V12H38.8V13.2H37V13.8H39V15H35.5V10Z"
        fill="#231F20"
      />
      <path
        d="M39.5 10H41L39.5 12.5L41 15H39.5L38.5 13L39.5 10Z"
        fill="#231F20"
      />
    </svg>
  );
};

export default Discover;
